// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"760":"0f304c6ab3d9d1bd","9626":"c9331e8b99eacc35"}[chunkId] + ".css";
};